// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"a9e185d2e5f4363d880e","655":"eddcfec72d9791a67fed"}[chunkId] + ".js";
};